export const boardCompletedFormsTour = {
  key: "boardCompletedForms",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-completedforms-tabs"]',
      content: t("Tour_BoardCompletedForms_Tabs"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-completedforms-filters"]',
      content: t("Tour_BoardCompletedForms_Filters"),
      placement: "top",
    },
    {
      target: '[data-tour="board-completedforms-table"]',
      content: t("Tour_BoardCompletedForms_Table"),
      placement: "top",
    },
  ],
};
